@if (isLoggedIn) {
  <a class="kb-notifications-icon" (click)="getNotification()"
    >
    <img class="bell-icon" src="/images/bell_grey.png" alt="" />
    @if (isLoggedIn&&(notificationCount>0||notificationCount!=undefined)) {
      <span class="kb-notifications-count">{{notificationCount}}</span>
    }
  </a>
}
@if (showNotification) {
  <div class="notificationWrapper">
    <div class="triangle"></div>
    <div class="notificationPopup">
      @if (isLoggedIn&&notificationCount>0) {
        <p>{{notificationsData?.count}}{{'common.notifications_available'|cxTranslate}}</p>
      }
      @if (isLoggedIn&&(notificationCount<=0||notificationCount==undefined)) {
        <p>{{'common.notifications_not_available'|cxTranslate}}</p>
      }
      @for (notification of notificationsData?.kbNotications; track notification) {
        <div class="notification-box">
          <div class="row col-12 px-0">
            <div class="col-8">
              @if (notification?.notificationType=='ReportDocument') {
                <div>
                  <a routerLink="kbReportDownloadPage" target="_blank"
                    (click)="deleteNotification(notification?.notificationCode)">
                  {{ notification?.notificationName }}</a>
                </div>
              }
              <div class="Kb-timeStamp">{{notification?.notificationDate}}</div>
            </div>
            <div class="col-4 px-0 kbdeleteNotification">
              <span (click)="deleteNotification(notification?.notificationCode)"> <img class="closeSvg"
              src="/images/deleteIcon.png" /></span>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
